export enum SectionIds {
  ConversationHub = 101,
  ConciergeDashboard = 95,
}
